import Reports from '@/views/Reports/Index'

// Raporty zarządzającego
import ReportsReportsShiftSummaries from '@/views/Reports/ReportsShiftSummaries/Index'
import ReportsReportsShiftSummariesReportsShiftSummaries from '@/views/Reports/ReportsShiftSummaries/ReportsShiftSummaries'
import ReportsReportsShiftSummariesDetailedReports from '@/views/Reports/ReportsShiftSummaries/DetailedReports'

// Raporty szczegółowe zarządzającego (nadawanie)
import ReportsShipmentsReportsShiftSummariesDetailedShipmentsReports from '@/views/Reports/ReportsShiftSummaries/DetailedShipmentsReports'

// Raporty operatora
import ReportsUserReportsShiftSummaries from '@/views/Reports/UserReportsShiftSummaries/Index'
import ReportsUserReportsShiftSummariesUserReportsShiftSummaries from '@/views/Reports/UserReportsShiftSummaries/UserReportsShiftSummaries'
import ReportsUserReportsShiftSummariesDetailedReports from '@/views/Reports/UserReportsShiftSummaries/DetailedReports'

// Raporty szczegółowe operatora (nadawanie)
import ReportsUserReportsShiftSummariesDetailedShipmentsReports from '@/views/Reports/UserReportsShiftSummaries/DetailedShipmentsReports'

// Raportowanie
import ReportsReporting from '@/views/Reports/Reporting/Index'
import ReportsReportingReporting from '@/views/Reports/Reporting/Reporting'
import ReportsReportingCreateReport from '@/views/Reports/Reporting/CreateReport'
import ReportsReportingCreatePrintReport from '@/views/Reports/Reporting/CreatePrintReport'

// Raportowanie papieru
import ReportsPaperReporting from '@/views/Reports/Reporting/Index'
import ReportsPaperReportingPaperReporting from '@/views/Reports/PaperReporting/PaperReporting'
import ReportPaperReportingPaperReportingPaperDetailedReports from '@/views/Reports/PaperReporting/DetailedPaperReports'

// Pojedynczy raport szczegółowy
import ReportsCommonReport from '@/views/Reports/Common/Report'

// Pojedynczy raport szczegółowy nadawania
import ReportsCommonShipmentReport from '@/views/Reports/Common/ShipmentReport'


export default [
    {
        path: '/reports',
        name: 'reports',
        component: Reports,
        meta: {
            title: 'Czas pracy',
            menuRendered: true,
            menuTitle: 'Czas pracy',
            permission: 'reports',
            icon: 'mdi-clock-outline',
        },
        // redirect: { name: 'reportsReportsShiftSummaries' },
        children: [
            {
                path: '/reports/reports-shift-summaries',
                name: 'reportsReportsShiftSummaries',
                component: ReportsReportsShiftSummaries,
                meta: {
                    title: 'Czas pracy / Zatwierdzenia',
                    menuRendered: true,
                    menuTitle: 'Zatwierdzenia',
                    requiresAuth: true,
                    permission: 'reports_review',
                },
                redirect: { name: 'reportsReportsShiftSummariesReportsShiftSummaries' },
                children: [
                    {
                        path: '/reports/reports-shift-summaries',
                        name: 'reportsReportsShiftSummariesReportsShiftSummaries',
                        component: ReportsReportsShiftSummariesReportsShiftSummaries,
                        meta: {
                            title: 'Czas pracy / Zatwierdzenia',
                            requiresAuth: true,
                            permission: 'reports_review',
                        },
                    },
                    {
                        path: '/reports/reports-shift-summaries/:id',
                        name: 'reportsReportsShiftSummariesDetailedReports',
                        component: ReportsReportsShiftSummariesDetailedReports,
                        meta: {
                            title: 'Czas pracy / Zatwierdzenia / Rozliczenia czasu pracy',
                            requiresAuth: true,
                            permission: 'reports_review',
                        },
                    },
                    {
                        path: '/reports/reports-shift-summaries/:reportShiftSummaryId/reports/:id',
                        name: 'reportsReportsShiftSummariesReportsReport',
                        component: ReportsCommonReport,
                        meta: {
                            title: 'Czas pracy / Zatwierdzenia / Rozliczenia czasu pracy / Szczegóły raportu',
                            requiresAuth: true,
                            permission: 'reports_review',
                        },
                    },
                    {
                        path: '/reports/shipments-reports-shift-summaries/:id',
                        name: 'reportsShipmentsReportsShiftSummariesDetailedShipmentsReports',
                        component: ReportsShipmentsReportsShiftSummariesDetailedShipmentsReports,
                        meta: {
                            title: 'Czas pracy / Zatwierdzenia / Rozliczenia czasu pracy',
                            requiresAuth: true,
                            permission: 'shipments_admin_read',
                        },
                    },
                    {
                        path: '/reports/shipments-reports-shift-summaries/reports/:id',
                        name: 'reportsShipmentsReportsShiftSummariesShipmentReport',
                        component: ReportsCommonShipmentReport,
                        meta: {
                            title: 'Czas pracy / Zatwierdzenia / Rozliczenia czasu pracy / Szczegóły raportu',
                            requiresAuth: true,
                            permission: 'shipments_admin_read',
                        },
                    },
                ]
            },
            {
                path: '/reports/reporting',
                name: 'reportsReporting',
                component: ReportsReporting,
                meta: {
                    title: 'Czas pracy / Raportowanie',
                    menuRendered: true,
                    menuTitle: 'Raportowanie',
                    requiresAuth: true,
                    permission: 'reports',
                },
                redirect: { name: 'reportsReportingReporting' },
                children: [
                    {
                        path: '/reports/reporting',
                        name: 'reportsReportingReporting',
                        component: ReportsReportingReporting,
                        meta: {
                            title: 'Czas pracy / Raportowanie',
                            requiresAuth: true,
                            permission: 'reports',
                        },
                    },
                    {
                        path: '/reports/reporting/create',
                        name: 'ReportsReportingCreate',
                        component: ReportsReportingCreateReport,
                        meta: {
                            title: 'Czas pracy / Raportowanie / Nowy raport',
                            requiresAuth: true,
                            permission: 'reports_create',
                        },
                    },
                    {
                        path: '/reports/reporting/print-create',
                        name: 'ReportsReportingCreatePrint',
                        component: ReportsReportingCreatePrintReport,
                        meta: {
                            title: 'Czas pracy / Raportowanie / Nowy raport',
                            requiresAuth: true,
                            permission: 'reports_create',
                        },
                    },
                    {
                        path: '/reports/reporting/:id',
                        name: 'reportsReportingReport',
                        component: ReportsCommonReport,
                        meta: {
                            title: 'Czas pracy / Raportowanie / Szczegóły raportu',
                            requiresAuth: true,
                            permission: 'reports',
                        },
                    }
                ]
            },
            {
                path: '/reports/paper-reporting',
                name: 'reportsPaperReporting',
                component: ReportsPaperReporting,
                meta: {
                    title: 'Czas pracy / Raportowanie papieru',
                    menuRendered: true,
                    menuTitle: 'Raportowanie papieru',
                    requiresAuth: true,
                    permission: 'paper_report',
                },
                redirect: { name: 'reportsPaperReportingPaperReporting' },
                children: [
                    {
                        path: '/reports/paper-reporting',
                        name: 'reportsPaperReportingPaperReporting',
                        component: ReportsPaperReportingPaperReporting,
                        meta: {
                            title: 'Czas pracy / Raportowanie papieru',
                            requiresAuth: true,
                            permission: 'paper_report',
                        },
                    },
                    {
                        path: '/reports/paper-reporting/:id',
                        name: 'reportsDetailedPaperReports',
                        component: ReportPaperReportingPaperReportingPaperDetailedReports,
                        meta: {
                            title: 'Czas pracy / Raportowanie / Szczegóły raportu',
                            requiresAuth: true,
                            permission: 'reports',
                        },
                    }
                ]
            },
            {
                path: '/reports/user-reports-shift-summaries',
                name: 'reportsUserReportsShiftSummaries',
                component: ReportsUserReportsShiftSummaries,
                meta: {
                    title: 'Czas pracy / Moje raporty',
                    menuRendered: true,
                    menuTitle: 'Moje raporty',
                    requiresAuth: true,
                    permission: 'reports',
                },
                redirect: { name: 'reportsUserReportsShiftSummariesUserReportsShiftSummaries' },
                children: [
                    {
                        path: '/reports/user-reports-shift-summaries',
                        name: 'reportsUserReportsShiftSummariesUserReportsShiftSummaries',
                        component: ReportsUserReportsShiftSummariesUserReportsShiftSummaries,
                        meta: {
                            title: 'Czas pracy / Moje raporty',
                            requiresAuth: true,
                            permission: 'reports',
                        },
                    },
                    {
                        path: '/reports/user-reports-shift-summaries/:id',
                        name: 'reportsUserReportsShiftSummariesDetailedReports',
                        component: ReportsUserReportsShiftSummariesDetailedReports,
                        meta: {
                            title: 'Czas pracy / Moje raporty / Rozliczenia czasu pracy',
                            requiresAuth: true,
                            permission: 'reports',
                        },
                    },
                    {
                        path: '/reports/user-reports-shift-summaries/:reportShiftSummaryId/reports/:id',
                        name: 'reportsUserReportsShiftSummariesDetailedReportsReport',
                        component: ReportsCommonReport,
                        meta: {
                            title: 'Czas pracy / Moje raporty / Szczegóły raportu',
                            requiresAuth: true,
                            permission: 'reports',
                        },
                    },
                    {
                        path: '/reports/user-shipments-reports-shift-summaries/:id',
                        name: 'reportsUserShipmentsReportsShiftSummariesDetailedShipmentsReports',
                        component: ReportsUserReportsShiftSummariesDetailedShipmentsReports,
                        meta: {
                            title: 'Czas pracy / Moje raporty / Rozliczenia czasu pracy',
                            requiresAuth: true,
                            permission: 'shipments_read',
                        },
                    },
                    {
                        path: '/reports/user-shipments-reports-shift-summaries/:reportShiftSummaryId/:id',
                        name: 'reportsUserShimpentReportsShiftSummariesDetailedShipmentsReportsReport',
                        component: ReportsCommonShipmentReport,
                        meta: {
                            title: 'Czas pracy / Moje raporty / Szczegóły raportu',
                            requiresAuth: true,
                            permission: 'shipments_read',
                        },
                    },
                ]
            },
        ],
    },
]